module.exports = __webpack_public_path__ + "img/ChurchplusLogo2-highres.5d41b522.png";